import React, { useState, useEffect } from 'react';
import { X, Clock, ArrowRight } from 'lucide-react';
import { siteConfig } from '../mock';

const BlackFridayPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const promoKey = `promoDismissed:${siteConfig.promo.currentYearMonth}`;

  useEffect(() => {
    // Check if user has closed popup for this month
    const hasClosedPopup = localStorage.getItem(promoKey);

    if (!hasClosedPopup) {
      // Show popup after 2 seconds
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [promoKey]);

  const handleClose = () => {
    setIsOpen(false);
    localStorage.setItem(promoKey, 'true');
  };

  const whatsappLink = `https://wa.me/${siteConfig.whatsapp}?text=${encodeURIComponent('Quero aproveitar a Promoção do Mês CompreCliente!')}`;

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[100] transition-opacity duration-300"
        onClick={handleClose}
      />

      {/* Popup */}
      <div className="fixed inset-0 z-[101] flex items-center justify-center p-4">
        <div className="relative bg-black border-2 border-[#D4AF37] rounded-2xl max-w-2xl w-full p-8 md:p-12 animate-fade-in shadow-2xl">
          {/* Close Button */}
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors p-2"
            aria-label="Fechar"
          >
            <X size={28} />
          </button>

          {/* Content */}
          <div className="text-center">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-[#D4AF37]/20 border border-[#D4AF37] px-6 py-3 rounded-full mb-6">
              <Clock className="text-[#D4AF37]" size={20} />
              <span className="text-[#D4AF37] font-semibold text-sm uppercase tracking-wide">
                OFERTA DO MÊS
              </span>
            </div>

            {/* Title */}
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">
              10%
              <span className="text-3xl md:text-4xl font-bold text-[#D4AF37] ml-2">
                OFF
              </span>
            </h2>

            {/* Subtitle */}
            <div className="mb-6">
              <p className="text-2xl font-bold text-white mt-2">
                Promoção de {siteConfig.promo.monthName}
              </p>
            </div>

            {/* Description */}
            <p className="text-xl text-gray-300 mb-8 max-w-lg mx-auto">
              Nos planos <strong className="text-[#D4AF37]">INTERMEDIÁRIO</strong> e <strong className="text-[#D4AF37]">AVANÇADO</strong>. Domine seu mercado com a CompreCliente.
            </p>

            {/* CTA Button */}
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-[#D4AF37] text-black px-10 py-5 text-lg font-bold rounded-lg transition-all duration-300 hover:scale-105 hover:bg-[#D4AF37]/90"
            >
              Aproveitar Agora
              <ArrowRight size={24} />
            </a>

            {/* Small Print */}
            <p className="text-sm text-gray-500 mt-6">
              Válido até {siteConfig.promo.expires.toLocaleDateString('pt-BR')} • Vagas limitadas
            </p>
          </div>

          {/* Decorative Elements */}
          <div className="absolute -top-20 -left-20 w-40 h-40 bg-[#D4AF37]/20 rounded-full blur-3xl" />
          <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-[#D4AF37]/20 rounded-full blur-3xl" />
        </div>
      </div>
    </>
  );
};

export default BlackFridayPopup;
